<template>
  <el-card shadow="never" class="reporting-content">
    <el-row :gutter="20">
      <el-col :span="14" :offset="0">
        <el-row :gutter="50">
          <el-col :span="14">
            <ul>
              <li><span class="text">Taxpayer Classification:</span><span class="value">{{ taxPayerClassificationName }}</span></li>
              <li v-if="form.psocId"><span class="text">Occupation (PSOC):</span><span class="value">{{ psocName }}</span></li>
              <li v-if="form.psicId"><span class="text">Line of Business (PSIC):</span><span class="value">{{ psicName }}</span></li>
              <li><span class="text">Filing Method:</span><span class="value">{{ fillingMethodsName }}</span></li>
            </ul>
          </el-col>
          <el-col :span="10">
            <div class="block-title">
              Branch Offices
            </div>
            <el-button style="margin-top: 30px; width: 100%" type="primary" size="small" :disabled="!form.branchOffices" @click="openBranchOfficeModal">Open Branch Office Table</el-button>
          </el-col>
        </el-row>
        <el-row :gutter="50" style="margin-top: 30px;">
          <el-col :span="14">
            <div class="block-title">
              Reporting Settings
            </div>
          </el-col>
          <el-col :span="10">
            <div class="block-title">
              BIR Filing Tables
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="50" style="margin-top: 30px;">
          <el-col :span="14">

            <div class="block-title">
              President/Vice President/Principal Officer/Accredited Tax Agent/Authorised Representative/Taxpayer
            </div>
            <ul style="margin-top: 10px;">
              <li><span class="text">Name:</span><span class="value">{{form.settingsName}}</span></li>
              <li><span class="text">Title/Position of Signatory:</span><span class="value">{{form.titlePositionOfSignatory}}</span></li>
              <li><span class="text">TIN of Signatory:</span><span class="value">{{form.tinOfSignatory}}</span></li>
            </ul>

            <div class="block-title">
              Treasurer/Assistant Treasurer
            </div>
            <ul style="margin-top: 10px;">
              <li><span class="text">Name:</span><span class="value">{{form.treasurerName}}</span></li>
              <li><span class="text">Title/Position of Signatory:</span><span class="value">{{form.treasurerPositionOfSignatory}}</span></li>
              <li><span class="text">TIN of Signatory:</span><span class="value">{{form.treasurerTinOfSignatory}}</span></li>
            </ul>

            <div class="block-title">
              Tax Agent Acc. No./Atty's Roll No. (if applicable)
            </div>
            <ul style="margin-top: 10px;">
              <li><span class="text">Name:</span><span class="value">{{form.agentName}}</span></li>
              <li><span class="text">Date of Issuance:</span><span class="value">{{form.dateOfIssuance}}</span></li>
              <li><span class="text">Date of Expiry:</span><span class="value">{{form.dateOfExpiry}}</span></li>
            </ul>
          </el-col>
          <el-col :span="10">
            <div>
              <el-button style="width: 100%;" type="primary" size="small" @click="openFillingModal('71')">Open VAT/Percentage Table</el-button>
            </div>
            <div>
              <el-button style="width: 100%; margin-top: 30px;" type="primary" size="small" @click="openFillingModal('72')">Open Withholding Tax Table</el-button>
            </div>
            <div>
              <el-button style="width: 100%; margin-top: 30px;" type="primary" size="small" @click="openFillingModal('73')">Open Income Tax Table</el-button>
            </div>
            <div>
              <el-button style="width: 100%; margin-top: 30px;" type="primary" size="small" @click="openFillingModal('74')">Open Branch Forms Table</el-button>
            </div>
            <div>
              <el-button style="width: 100%; margin-top: 30px;" type="primary" size="small" @click="openFillingModal('75')">Open Misc/Others Table</el-button>
            </div>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <filling-tables-modal ref="fillingModal" readonly />
    <branch-office-modal ref="branchOfficeModal" readonly />
  </el-card>
</template>

<script>
import FillingTablesModal from "../../settings/organizationInformation/FillingTablesModal";
import BranchOfficeModal from "../../settings/organizationInformation/BranchOfficeModal";
import axios from "axios";
import moment from 'moment'
export default {
name: "ReportingContent",
  components: {
    BranchOfficeModal,
    FillingTablesModal
  },
  computed: {
    companyLayout() {
      return this.$store.getters.getCompanyLayout
    },
    taxPayerClassificationName() {
      const taxPayer = this.taxpayerClassifications.find(val => val.id === this.form.taxpayerClassificationId)
      return taxPayer ? taxPayer.name : null
    },
    psocName() {
      const psoc = this.psocs.find(val => val.id === this.form.psocId)
      return psoc ? psoc.name : null
    },
    psicName() {
      const psic = this.psics.find(val => val.id === this.form.psicId)
      return psic ? psic.name : null
    },
    fillingMethodsName() {
      const fillindMethod = this.fillingMethods.find(val => val.id === this.form.fillingMethodId)
      return fillindMethod ? fillindMethod.name : null
    }
  },
  data() {
    return {
      moment: moment,
      form: {
        taxpayerClassificationId: null,
        psicId: null,
        psocId: null,
        fillingMethodId: null,
        //
        isPsic: 1,
        //
        agentName: null,
        dateOfIssuance: null,
        dateOfExpiry: null,
        branchOffices: false,
        //
        settingsName: null,
        titlePositionOfSignatory: null,
        tinOfSignatory: null,
        //
        treasurerName: null,
        treasurerPositionOfSignatory: null,
        treasurerTinOfSignatory: null
      },
      psics: [],
      psocs: [],
      taxpayerClassifications: [],
      fillingMethods: []
    }
  },
  mounted() {
    this.$store.dispatch('getCompanyLayout').then(response => {
      this.getItem()
      this.getPsicList()
      this.getPsocList()
      this.getTaxpayerClassifications()
      this.getFillingMethods()
    })
  },
  methods: {
    getItem() {
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios.get(`/api/v1/company-reporting-info/item?companyId=${this.$route.query.companyId}`).then(response => {
        this.form.taxpayerClassificationId = response.data.item.taxpayerClassificationId
        this.form.psicId = response.data.item.psicId
        this.form.psocId = response.data.item.psocId
        this.form.fillingMethodId = response.data.item.fillingMethodId
        this.form.isPsic = response.data.item.isPsic
        this.form.agentName = response.data.item.agentName
        this.form.dateOfIssuance = response.data.item.dateOfIssuance ? moment(response.data.item.dateOfIssuance, 'DDMMYYYY').format('DD MMM YYYY') : null
        this.form.dateOfExpiry = response.data.item.dateOfExpiry ? moment(response.data.item.dateOfExpiry, 'DDMMYYYY').format('DD MMM YYYY') : null
        this.form.branchOffices = response.data.item.branchOffices
        this.form.settingsName = response.data.item.settingsName
        this.form.titlePositionOfSignatory = response.data.item.titlePositionOfSignatory
        this.form.tinOfSignatory = response.data.item.tinOfSignatory
        this.form.treasurerName = response.data.item.treasurerName
        this.form.treasurerPositionOfSignatory = response.data.item.treasurerPositionOfSignatory
        this.form.treasurerTinOfSignatory = response.data.item.treasurerTinOfSignatory
        loader.hide()
      }).catch(err => {
        loader.hide()
      })
    },
    getPsicList() {
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios.get(`/api/v1/psic/list?countryId=${this.companyLayout.countryId}`).then(response => {
        this.psics = response.data.list
        loader.hide()
      }).catch(err => {
        loader.hide()
      })
    },
    getPsocList() {
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios.get(`/api/v1/psoc/list?countryId=${this.companyLayout.countryId}`).then(response => {
        this.psocs = response.data.list
        loader.hide()
      }).catch(err => {
        loader.hide()
      })
    },
    getTaxpayerClassifications() {
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios.get(`/api/v1/taxpayer-classification/list?countryId=${this.companyLayout.countryId}`).then(response => {
        this.taxpayerClassifications = response.data.list
        loader.hide()
      }).catch(err => {
        loader.hide()
      })
    },
    getFillingMethods() {
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios.get(`/api/v1/filling-method/list?countryId=${this.companyLayout.countryId}`).then(response => {
        this.fillingMethods = response.data.list
        loader.hide()
      }).catch(err => {
        loader.hide()
      })
    },
    openFillingModal(entityTypeId) {
      this.$refs.fillingModal.openModal(entityTypeId)
    },
    openBranchOfficeModal() {
      this.$refs.branchOfficeModal.openModal()
    },
  }
}
</script>

<style lang="scss" scoped>
.reporting-content {
  ul {
    margin: 0;
    list-style: none;
    padding-left: 0;
    li {
      width: 100%;
      display: flex;
      align-items: center;
      margin: 10px 0;
      &:first-child {
        margin-top: 0;
      }
      .text {
        font-size: 18px;
        color: grey;
      }
      .value {
        margin-left: 10px;
      }
    }
  }
  .block-title {
    font-size: 18px;
    font-weight: bold;
  }
}
</style>
